import { createChatBotMessage } from "react-chatbot-kit";

const config = {
  botName: "SiteBot",
  initialMessages: [
    createChatBotMessage("Cześć! Jak mogę Ci pomóc?"),
  ],
  customStyles: {
    botMessageBox: {
      backgroundColor: "#6366f1",
    },
    chatButton: {
      backgroundColor: "#6366f1",
    },
  },
};

export default config;
